var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.401,
    height: 10.85,
    viewBox: "0 0 10.401 10.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_60",
    "data-name": "Subtraction 60",
    d: "M-9074.2,1227.35a.708.708,0,0,1-.5-.21l-3.14-3.142a.708.708,0,0,1-.155-.775.706.706,0,0,1,.656-.44h8.529a.712.712,0,0,1,.713.711.714.714,0,0,1-.713.713h-6.811l1.928,1.928a.714.714,0,0,1,0,1A.708.708,0,0,1-9074.2,1227.35Zm4.938-6.284h-8.528a.713.713,0,0,1-.711-.713.712.712,0,0,1,.711-.711h6.813l-1.93-1.928a.714.714,0,0,1,0-1,.708.708,0,0,1,.5-.21.715.715,0,0,1,.5.207l3.143,3.142a.715.715,0,0,1,.152.777A.707.707,0,0,1-9069.26,1221.066Z",
    transform: "translate(9078.499 -1216.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.baabbdf85fea6fafa636af7130509d30.svg";
export { ForwardRef as ReactComponent };